import {StandardModelV1} from '../../GeneratedModels/Standard/StandardModel.v1';

import StandardModelValidators from './StandardModel.v1.validators';

StandardModelV1.addValidators(StandardModelValidators);

export {StandardModelV1};
